module.exports = __webpack_public_path__ + "img/6060_2.a5de93f4.png";